"use client"
import { useEffect } from 'react';
import './App.css';
import AtomsBreakline from './components/atoms/AtomsBreakline';
import AtomsText from './components/atoms/AtomsText';
import MoleculesAppsBox from './components/molecules/MoleculesAppsBox';
import MoleculesOthersAppsBox from './components/molecules/MoleculesOthersAppsBox';
import OrganismsCreatorInfo from './components/organisms/OrganismsCreatorInfo';
import OrganismsFooter from './components/organisms/OrganismsFooter';
import OrganismsWelcome from './components/organisms/OrganismsWelcome';

const dailyAppsData = [
  { name: "GudangKu", description: "Inventory or Warehouse Apps", src_bg:'/assets/gudangku_apps_image.png', src_logo:'/assets/gudangku_logo.png', url: 'https://gudangku.leonardhors.com' },
  { name: "PinMarker", description: "Mark A Location & Visit History", src_bg:'/assets/pinmarker_apps_image.png', src_logo:'/assets/pinmarker_logo.png', url: 'https://pinmarker.leonardhors.com' },
  { name: "Wardrobe", description: "Outfit Management", src_bg:'/assets/wardrobe_apps_image.png', src_logo:'/assets/wardrobe_logo.png', url: 'https://wardrobe.leonardhors.com' },
  { name: "Kumande", description: "Daily Consume Tracking", src_bg:'/assets/kumande_apps_image.png', src_logo:'/assets/kumande_logo.png' },
  { name: "Moneh", description: "Money Management", src_bg:'/assets/moneh_apps_image.png', src_logo:'/assets/moneh_logo.png' },
  { name: "MyRide", description: "Vehicle Management & Care", src_bg:'/assets/myride_apps_image.png', src_logo:'/assets/myride_logo.png', url: 'https://myride.leonardhors.com' },
  { name: "DailyReminder", description: "Simple Daily Reminder", src_bg:'/assets/dailyreminder_apps_image.png', src_logo:'/assets/dailyreminder_logo.png', url: 'https://dailyreminder.leonardhors.com' },
  { name: "Stakk", description: "Create Some Notes", src_bg:'/assets/stakk_apps_image.png', src_logo:'/assets/stakk_logo.png' }
]

const othersAppsData = [
  { name: "Portfolio", description: "My Personal Portfolio" },
  { name: "AnimalPedia", description: "Encyclopedia of Animals" },
  { name: "MyAry", description: "Diary and Lifestory Analyze" },
  { name: "Custom Analytic : World War 2", description: "My Personal Portfolio" },
  { name: "MI-FIK", description: "Tel-U's FIK Activity Planning" },
  { name: "Atepp", description: "API Testing Apps" },
  { name: "Tracker", description: "Location Management for All Founded Coordinate in FlazenApps" },
  { name: "TrynCatch", description: "Apps Error Logging Management" },
  { name: "Checkout", description: "Personal Home Check In & Out History" },
  { name: "Chart Playground", description: "Automatic Data Visualization" },
  { name: "Servant", description: "Home Dashboard" },
]

const datasetData = [
  { name: "Global-Space-Exploration", description: "Tracking Global Space Missions and Innovations" },
  { name: "World Weather Repository", description: "Weather Sensor Result in Every Country" },
  { name: "Mobile Dataset", description: "Released Mobile Device For Every Brand" },
  { name: "Customer Shopping", description: "Fashion Store's Sales Data" },
  { name: "HR Analytics Dataset", description: "Company Employee Data" },
  { name: "Global Cybersecurity Threats", description: "All Cyber Attack Data" },
  { name: "Airplane Crashes Dataset Since 1908", description: "All Airplane Crash Dataset" },
  { name: "100 Healthiest Foods Nutrition and Origin Public", description: "Top 100 Healthiest Food" },
  { name: "Animal Analyzing", description: "Animal Analyze Result Dataset" },
  { name: "50K Songs Dataset Generated byA ", description: "Dummy Song Dataset" },
]

function App() {
  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.bundle")
    const startAudio = () => {
      const audio = new Audio('/song/main_bg_song.mp3')
      audio.loop = true
      audio.play()
      window.removeEventListener('click', startAudio)
    }
  
    window.addEventListener('click', startAudio)
  }, []);

  return (
    <div className="App">
      <OrganismsWelcome/>
      <AtomsBreakline length={5}/>
      <div className='content'>
        <OrganismsCreatorInfo/>
        <AtomsBreakline length={5}/>
        <AtomsText type='title' text='My Daily Usefull Apps'/>
        <AtomsText type='content' text='Explore my various apps that help do my daily routine'/>
        <div className='row mt-4'>
          {
            dailyAppsData.map((dt, idx) => (
              <div key={idx} className="col-md-6 col-sm-12">
                <MoleculesAppsBox name={dt.name} desc={dt.description} src_bg={dt.src_bg} src_logo={dt.src_logo} url={dt.url}/>
              </div>
            ))
          }
        </div>
        <AtomsBreakline length={5}/>
        <div className='container mx-0'>
          <AtomsText type='title' class='text-center-mobile' text='Others Apps'/>
          <AtomsText type='content' class='text-center-mobile' text="Here's my various apps that I dont know why Im creating this 😄"/>
          <div className='row mt-4'>
            {
              othersAppsData.map((dt, idx) => (
                <div key={idx} className="col-md-6 col-sm-12">
                  <MoleculesOthersAppsBox name={dt.name} desc={dt.description}/>
                </div>
              ))
            }
          </div>
        </div>
        <AtomsBreakline length={5}/>
        <div className='container mx-0'>
          <AtomsText type='title' class='text-center-mobile' text='My Dataset Analyze'/>
          <AtomsText type='content' class='text-center-mobile' text="Im also learning to visualize chart and get summary from various dataset"/>
          <div className='row mt-4'>
            {
              datasetData.map((dt, idx) => (
                <div key={idx} className="col-md-6 col-sm-12">
                  <MoleculesOthersAppsBox name={dt.name} desc={dt.description}/>
                </div>
              ))
            }
          </div>
        </div>
        <AtomsBreakline length={5}/>
      </div>
      <OrganismsFooter/>
    </div>
  );
}

export default App;
